<template>
	<div>
		<div class="sections">
			<section v-if="withPersonalData">
				<h3>Mein Name</h3>
				<b-row>
					<b-col md="2">
						<FormGroup label="Anrede">
							<SalutationSelect v-model="salutation"/>
						</FormGroup>
					</b-col>
					<b-col md="3" class="mt-2 mt-md-0">
						<FormGroup label="Vorname">
							<b-input v-model="firstName"/>
						</FormGroup>
					</b-col>
					<b-col md="3" class="mt-2 mt-md-0">
						<FormGroup label="Nachname">
							<b-input v-model="lastName"/>
						</FormGroup>
					</b-col>
				</b-row>
			</section>
			<section v-if="type">
				<div v-if="type === types.external" class="mb-3">
					<div>
						Da du als externer Berater/Vermittler/Dienstleister im Auftrag eines anderen Unternehmens tätig
						bist, ist für die Zufriedenheit von Kandidaten und Firmen (Verhinderung von Mehrfachsendung von
						Kandidaten an die gleiche Auftraggeberfirma) und den absoluten Geheimhaltungs- und Datenschutz
						sowie für die Verrechnung von unseren kostenpflichtigen Dienstleistungen erforderlich:
					</div>
					<ul class="bullet-points mt-3 pl-4">
						<li>die Angabe eures Auftraggebers</li>
						<li>die Angabe deines Unternehmens, in welchem du als externer Vermittler/Berater/Dienstleister
							tätig bist
						</li>
					</ul>
					<div class="mt-3">
						Deine Angaben werden absolut vertraulich behandelt und nicht an den Mitbewerb weitergegeben!
						Falsche Angaben führen zur Anzeige.
					</div>
				</div>
				<h3>{{ dataTitle }}</h3>
				<div class="mt-3">
					<FormGroup
						:label="companyNameLabel"
						:state="companyNameValid"
						:invalid-feedback="companyNameError"
						feedback-beneath
					>
						<b-input v-model="companyName"/>
					</FormGroup>
					<FormGroup
						label="Meine Rolle/Funktion im Unternehmen/in der Organisation"
						:state="roleValid"
						:invalid-feedback="roleError"
						feedback-beneath
						class="mt-3"
					>
						<b-input v-model="role"/>
					</FormGroup>
					<b-row class="mt-3">
						<b-col md="4">
							<FormGroup
								label="Staat"
								:state="countryValid"
								invalid-feedback="Bitte wähle einen Staat aus"
								feedback-beneath
							>
								<CountrySelect
									v-model="country"
									:meta="meta"
								/>
							</FormGroup>
						</b-col>
						<b-col md="2" class="mt-3 mt-md-0">
							<FormGroup
								label="PLZ"
								:state="zipValid"
								invalid-feedback="Bitte gib eine PLZ ein"
								feedback-beneath
							>
								<b-input v-model="zip"/>
							</FormGroup>
						</b-col>
						<b-col md="6" class="mt-3 mt-md-0">
							<FormGroup
								label="Ort"
								:state="cityValid"
								invalid-feedback="Bitte gib einen Ort ein"
								feedback-beneath
							>
								<b-input v-model="city"/>
							</FormGroup>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col md="8">
							<FormGroup
								label="Straße"
								:state="streetValid"
								invalid-feedback="Bitte gib eine Straße ein"
								feedback-beneath
							>
								<b-input v-model="street"/>
							</FormGroup>
						</b-col>
						<b-col md="4" class="mt-3 mt-md-0">
							<FormGroup
								label="Hausnummer"
								:state="streetNumberValid"
								invalid-feedback="Bitte gib eine Hausnummer ein"
								feedback-beneath
							>
								<b-input v-model="streetNumber"/>
							</FormGroup>
						</b-col>
					</b-row>
					<div class="mt-3">
						<!--<FormGroup
							label="Firmenbuchnummer: Findest du im Impressum der Firmen-Webseite"
							:state="companyNumberValid"
							:invalid-feedback="companyNumberError"
							feedback-beneath
						>
							<b-form-radio-group v-model="hasCompanyNumber" :options="hasCompanyNumberOptions"/>
							<div v-if="hasCompanyNumber" class="mt-3">
								<b-input v-model="companyNumber" placeholder="Firmenbuchnummer"/>
							</div>
						</FormGroup>-->
						<b-row class="mt-3">
							<b-col md="4">
								<FormGroup
									label="UID"
									feedback-beneath
								>
									<b-input v-model="vatNumber"/>
								</FormGroup>
							</b-col>
							<b-col md="8">
								<FormGroup
									label="Website des Unternehmens"
									feedback-beneath
								>
									<b-input v-model="website"/>
								</FormGroup>
							</b-col>
						</b-row>
					</div>
				</div>
			</section>
			<section v-if="isExternal">
				<h3>Daten eures Auftraggebers</h3>
				<FormGroup
					label="Firmenname: vollständiger Firmenname des zukünftigen Arbeitgebers - findest du im Impressum der Firmen-Webseite"
					:state="externalCompanyNameValid"
					invalid-feedback="Bitte gib den Firmennamen ein"
					feedback-beneath
				>
					<b-input v-model="externalCompanyName"/>
				</FormGroup>
				<!--<FormGroup
					label="Firmenbuchnummer: Findest du im Impressum der Firmen-Webseite"
					:state="externalCompanyNumberValid"
					:invalid-feedback="externalCompanyNumberError"
					feedback-beneath
					class="mt-3"
				>
					<b-form-radio-group v-model="hasExternalCompanyNumber" :options="hasCompanyNumberOptions"/>
					<div v-if="hasExternalCompanyNumber" class="mt-3">
						<b-input v-model="externalCompanyNumber" placeholder="Firmenbuchnummer"/>
					</div>
				</FormGroup>-->
			</section>
			<div class="my-4 text-right">
				<Button
					text="Speichern"
					icon="checkmark"
					:disabled="!dataValid || saving"
					:loading="saving"
					@click="save"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import FormGroup from "@/vue/common/form/Group.vue";
import CountrySelect from "@/vue/common/form/CountrySelect";
import InfoBox from "@/vue/common/InfoBox.vue";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull, stringOrNull, trim} from "@/helper/String";
import {mapState} from "vuex";
import Button from "@/vue/common/Button.vue";
import Save from "@/api/customer/data-completion/Save";
import flatten from "@/helper/error/Errors";
import * as Toast from "@/helper/layout/Toast";
import JonInfo from "@/vue/common/JonInfo.vue";
import SalutationSelect from "@/vue/common/form/SalutationSelect.vue";
import {EXTERNAL, INTERNAL} from "@/helper/customer/Type";

export default {
	components: {
		SalutationSelect,
		JonInfo,
		Button,
		CountrySelect,
		RadioGroup,
		InfoBox,
		FormGroup
	},

	props: {
		customer: {
			type: Object,
			required: false,
		},
		withPersonalData: {
			type: Boolean,
			required: false,
			default: false
		},
		dataComplete: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	data ()
	{
		let type = null;

		if (this.customer)
		{
			type = this.customer.type;
		}

		return {
			salutation: this.customer?.salutation,
			firstName: this.customer?.firstName,
			lastName: this.customer?.lastName,
			type,
			types: {
				internal: INTERNAL,
				external: EXTERNAL,
			},
			hasCompanyNumberOptions: [
				{value: true, text: 'Firma hat Firmenbuchnummer '},
				{value: false, text: 'Firma hat keine Firmenbuchnummer '},
			],
			companyName: this.customer?.companyName || '',
			hasCompanyNumber: isDefined(this.customer)
				? !isEmptyOrNull(this.customer.companyNumber)
				: null,
			companyNumber: this.customer?.companyNumber || '',
			country: this.customer?.country?.id || null,
			zip: this.customer?.zip || '',
			city: this.customer?.city || '',
			street: this.customer?.street || '',
			streetNumber: this.customer?.streetNumber || '',
			externalCompanyName: this.customer?.externalCompanyName || '',
			hasExternalCompanyNumber: isDefined(this.customer)
				? !isEmptyOrNull(this.customer.externalCompanyNumber)
				: null,
			externalCompanyNumber: this.customer?.externalCompanyNumber || '',
			website: this.customer?.website || '',
			vatNumber: this.customer?.vatNumber || '',
			role: this.customer?.role || '',
			saving: false
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		isInternal ()
		{
			return this.type === this.types.internal;
		},
		isExternal ()
		{
			return this.type === this.types.external;
		},
		dataTitle ()
		{
			return this.isInternal
				? 'Die/Der zukünftige Mitarbeiter/in wird in diesem Unternehmen tätig werden:'
				: 'Mein Unternehmen, welches als Berater/Vermittler/Dienstleister für das Auftraggeberunternehmen tätig ist:';
		},
		companyNameLabel ()
		{
			return this.isInternal
				? 'Firmenname: vollständiger Firmenname des zukünftigen Arbeitgebers - findest du im Impressum der Firmen-Webseite'
				: 'Firmenname der externen Vermittlung: vollständiger Firmenname deines Unternehmens, in welchem du als Berater/Vermittler/Dienstleister tätig bist: findest du im Impressum eurer Firmen-Webseite';
		},
		companyNameValid ()
		{
			return !isDefined(this.companyNameError);
		},
		companyNameError ()
		{
			if (isEmptyOrNull(this.companyName))
			{
				return 'Bitte gib den Firmennamen ein';
			}

			if (trim(this.companyName).length < 3)
			{
				return 'Bitte gib mindestens 3 Zeichen ein';
			}

			return null;
		},
		// companyNumberError ()
		// {
		// 	if (this.hasCompanyNumber === null)
		// 	{
		// 		return 'Bitte triff eine Auswahl';
		// 	}
		//
		// 	if (this.hasCompanyNumber === false)
		// 	{
		// 		return null;
		// 	}
		//
		// 	return isEmptyOrNull(this.companyNumber)
		// 		? 'Bitte gib eine Firmenbuchnummer ein'
		// 		: null;
		// },
		// companyNumberValid ()
		// {
		// 	return isEmptyOrNull(this.companyNumberError);
		// },
		// externalCompanyNumberError ()
		// {
		// 	if (!this.isExternal)
		// 	{
		// 		return null;
		// 	}
		//
		// 	if (this.hasExternalCompanyNumber === null)
		// 	{
		// 		return 'Bitte triff eine Auswahl';
		// 	}
		//
		// 	if (this.hasExternalCompanyNumber === false)
		// 	{
		// 		return null;
		// 	}
		//
		// 	return isEmptyOrNull(this.externalCompanyNumber)
		// 		? 'Bitte gib eine Firmenbuchnummer ein'
		// 		: null;
		// },
		personalDataValid ()
		{
			if (!this.withPersonalData)
			{
				return true;
			}

			return !isEmptyOrNull(this.salutation)
				&& !isEmptyOrNull(this.firstName)
				&& !isEmptyOrNull(this.lastName);
		},
		// externalCompanyNumberValid ()
		// {
		// 	return isEmptyOrNull(this.externalCompanyNumberError);
		// },
		countryValid ()
		{
			return !this.isInternal || isDefined(this.country);
		},
		zipValid ()
		{
			return !this.isInternal || !isEmptyOrNull(this.zip);
		},
		cityValid ()
		{
			return !this.isInternal || !isEmptyOrNull(this.city);
		},
		streetValid ()
		{
			return !this.isInternal || !isEmptyOrNull(this.street);
		},
		streetNumberValid ()
		{
			return !this.isInternal || !isEmptyOrNull(this.streetNumber);
		},
		externalCompanyNameValid ()
		{
			return !this.isExternal || !isEmptyOrNull(this.externalCompanyName);
		},
		roleValid ()
		{
			return isEmptyOrNull(this.roleError);
		},
		roleError ()
		{
			if (isEmptyOrNull(this.role))
			{
				return 'Bitte gib deine Rolle/Funktion ein';
			}

			return null;
		},
		dataValid ()
		{
			return this.personalDataValid
				&& this.companyNameValid
				// && this.companyNumberValid
				&& this.externalCompanyNameValid
				// && this.externalCompanyNumberValid
				&& this.countryValid
				&& this.zipValid
				&& this.cityValid
				&& this.streetValid
				&& this.streetNumberValid
				&& this.roleValid;
		}
	},

	methods: {
		async save ()
		{
			if (this.saving)
			{
				return;
			}

			this.saving = true;

			try
			{
				const save = new Save();

				if (this.withPersonalData)
				{
					save.setSalutation(this.salutation);
					save.setFirstName(this.firstName);
					save.setLastName(this.lastName);
				}

				save.setCompanyName(this.companyName);
				save.setRole(this.role);
				// save.setCompanyNumber(
				// 	this.hasCompanyNumber
				// 		? this.companyNumber
				// 		: null
				// );
				save.setCountry(this.country);
				save.setZip(this.zip);
				save.setCity(this.city);
				save.setStreet(this.street);
				save.setStreetNumber(this.streetNumber);
				save.setWebsite(
					stringOrNull(this.website)
				);
				save.setVatNumber(
					stringOrNull(this.vatNumber)
				);

				if (this.isExternal)
				{
					save.setExternalCompanyName(this.externalCompanyName);
					// save.setExternalCompanyNumber(
					// 	this.hasExternalCompanyNumber
					// 		? this.externalCompanyNumber
					// 		: null
					// );
				}

				await save.call();

				this.$emit('complete');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		}
	}
}
</script>
